"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultState = exports.changePrimaryType = exports.removeToast = exports.actionClicked = exports.changePhone = exports.CHANGE_PRIMARY_PHONE = exports.REMOVE_TOAST = exports.TYPE_ACTION = exports.REMOVE_PHONE = exports.CHANGE_PHONE = exports.BUILD_PHONE = void 0;
exports.BUILD_PHONE = "BUILD_PHONE";
exports.CHANGE_PHONE = "CHANGE_PHONE";
exports.REMOVE_PHONE = "REMOVE_PHONE";
exports.TYPE_ACTION = "OPTIONS_CLICKED";
exports.REMOVE_TOAST = "REMOVE_TOAST";
exports.CHANGE_PRIMARY_PHONE = "CHANGE_PRIMARY_PHONE";
function changePhone(phonesList) {
    return {
        type: [exports.CHANGE_PHONE],
        phones: phonesList,
    };
}
exports.changePhone = changePhone;
function actionClicked(value) {
    return {
        type: [exports.TYPE_ACTION],
        typeOfAction: value,
    };
}
exports.actionClicked = actionClicked;
function removeToast(value) {
    return {
        type: [exports.REMOVE_TOAST],
        typeOfAction: value,
    };
}
exports.removeToast = removeToast;
function changePrimaryType(value) {
    return {
        type: [exports.CHANGE_PRIMARY_PHONE],
        changePrimaryType: value,
    };
}
exports.changePrimaryType = changePrimaryType;
exports.DefaultState = {
    phones: "",
    typeOfAction: "",
    changePrimaryType: "",
    countries: "",
    ppcSynchronyDeeplinks: "",
};
